import { fresher } from '../../../sync/hooks';

type Stamped = NonNullable<Parameters<typeof fresher>[1]>;

/**
 * A board reading the sync engine's copy (#561), with the rows this board
 * saved itself laid over it: each is the newer of the two, as `fresher`
 * decides for a detail page. A dropped card's saved row is newer until
 * the engine's delta for it lands a moment later, so the card does not
 * jump back to its old column in between.
 */
export function withOwnRows<T extends Stamped>(
  synced: T[],
  own: ReadonlyMap<string, T>
): T[] {
  if (own.size === 0) return synced;
  return synced.map((row) => fresher(row, own.get(row.id) ?? null) ?? row);
}
